import Identifier from "./Identifier";

export default Identifier;
